import I18n from 'lib/i18n'
import './styles.scss'

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'kea'
import NProgress from 'nprogress'

import FloatingField from 'lib/forms/floating-field'

import controller from '~/scenes/search/controller.rb'

import sceneLogic from '~/scenes/search/logic'

@connect({
  props: [sceneLogic, ['filter']]
})
export default class NotFound extends Component {
  static propTypes = {
    bounds: PropTypes.array
  }

  constructor (props) {
    super(props)

    this.state = {
      submitted: false,
      submitting: false,
      values: {
        category: '',
        email: '',
        phone: '',
        location: ''
      },
      touched: false,
      errors: {}
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount () {
    const { filter } = this.props

    const initial = {
      activity: filter.query,
      location: filter.location
    }

    this.setState({ values: Object.assign({}, this.state.values, initial) })
  }

  validate = (values = this.state.values) => {
    const errors = {}

    if (!values.activity) {
      errors.activity = I18n.t('errors.messages.blank')
    }
    if (!values.location) {
      errors.location = I18n.t('errors.messages.blank')
    }
    if (!values.email || values.email.indexOf('@') === -1) {
      errors.email = I18n.t('errors.messages.blank')
    }
    if (!values.phone) {
      errors.phone = I18n.t('errors.messages.blank')
    }

    this.setState({ errors, invalid: Object.keys(errors).length > 0 })

    if (Object.keys(errors).length > 0) {
      return false
    }

    return true
  }

  handleSubmit = e => {
    const { bounds } = this.props
    const { values } = this.state

    e.preventDefault()

    this.setState({ touched: true })

    if (!this.validate()) {
      return
    }

    this.setState({ submitting: true })
    NProgress.start()

    controller
      .sendNotFoundForm({
        category: values.activity,
        email: values.email,
        phone: values.phone,
        location: values.location,
        neLat: bounds ? bounds[0][0] : null,
        neLng: bounds ? bounds[0][1] : null,
        swLat: bounds ? bounds[1][0] : null,
        swLng: bounds ? bounds[1][1] : null
      })
      .then(result => {
        NProgress.done()
        this.setState({ submitting: false })

        if (result.success) {
          this.setState({ submitted: true })
        }
      })
      .catch(() => {
        NProgress.done()
        this.setState({ submitting: false })
      })
  }

  updateField = (field, value) => {
    const values = Object.assign({}, this.state.values, { [field]: value })
    this.setState({ values: values })
    this.validate(values)
  }

  updateActivity = e => {
    this.updateField('activity', e.target.value)
  }

  updateLocation = e => {
    this.updateField('location', e.target.value)
  }

  updateEmail = e => {
    this.updateField('email', e.target.value)
  }

  updatePhone = e => {
    this.updateField('phone', e.target.value)
  }

  render () {
    const { submitted, submitting, values, errors, touched } = this.state

    return (
      <div className='no-results-found'>
        <h1>{I18n.t('react.search.not_found.header')}</h1>
        <div className='owl' />
        <div className='text-with-owl'>
          <p>{I18n.t('react.search.not_found.line_1')}</p>
          <p
            dangerouslySetInnerHTML={{
              __html: I18n.t('react.search.not_found.recruit', {
                link: `<a href='/courses/new'>${I18n.t('react.search.not_found.recruit_link')}</a>`
              })
            }}
          />
          <h2>{submitted ? I18n.t('react.search.not_found.thanks_1') : I18n.t('react.search.not_found.cta')}</h2>
          {submitted ? <p>{I18n.t('react.search.not_found.thanks_2')}</p> : null}
        </div>
        {submitted ? null : (
          <form onSubmit={this.handleSubmit}>
            <FloatingField
              input={{ value: values.activity, onChange: this.updateActivity }}
              placeholder={I18n.t('react.search.not_found.field_activity')}
              maxLength={50}
              meta={{ touched: touched, error: errors.activity }}
            />

            <FloatingField
              input={{ value: values.location, onChange: this.updateLocation }}
              placeholder={I18n.t('react.search.not_found.field_location')}
              maxLength={100}
              meta={{ touched: touched, error: errors.location }}
            />

            <FloatingField
              input={{ value: values.email, onChange: this.updateEmail }}
              placeholder={I18n.t('react.search.not_found.field_email')}
              maxLength={100}
              meta={{ touched: touched, error: errors.email }}
            />

            <FloatingField
              input={{ value: values.phone, onChange: this.updatePhone }}
              placeholder={I18n.t('react.search.not_found.field_phone')}
              maxLength={100}
              meta={{ touched: touched, error: errors.phone }}
            />

            <button type='submit' disabled={submitting}>
              {I18n.t('react.search.not_found.button')}
            </button>
          </form>
        )}
      </div>
    )
  }
}
